<template>
    <div id="c-video-list">
        <div class="col-lg-3 col-md-4 col-sm-6 resent-grid recommended-grid"  v-for="(value, index) in data" :key="index">
            <div class="resent-grid-img recommended-grid-img">

                <router-link :to="{ name: 'VideoWatch', params: { vid: value.vid } }">
                    <div class="zoomImage" :style="'background-image:url('+value.thumbnail+')'"></div>
                </router-link>

                <div class="edtime">
<!--                    <p>{{ getFormattedTime(value.length) }}</p>-->
                    <p>{{ value.length }}</p>
                </div>

                <div class="edclck">
                    <span class="glyphicon glyphicon-time" aria-hidden="true"></span>
                </div>
            </div>
            <div class="resent-grid-info recommended-grid-info video-info-grid">
                <h5>
                    <router-link :to="{ name: data.routeName, params: value.params }" class="title">
                        {{ value.title }}
                    </router-link>
                </h5>
                <ul>
<!--                    <li><p class="author author-info"><a href="javascript:void(0);" class="author" style="cursor:text;">CmsDemo</a></p></li>-->
<!--                    <li class="right-list views-date">{{ getFormattedDate(value.publish_time) }}</li>-->
                  <li class="views-date">{{ getFormattedDate(value.publish_time) }}</li>
                </ul>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
import { getFormattedDate, getFormattedTime, removeHtmlTags } from '@/utils/utility'

export default {
  name: 'cVideoList',
  props: ['data'],
  methods: {
    getFormattedDate,
    getFormattedTime,
    removeHtmlTags,
    myCallback: function (page) {
      let self = this
      self.$router.push({ name: self.$route.name, query: { p: page } })
    }
  }
}
</script>

<style scoped>
    .views {
        /*text-overflow: ellipsis;*/
        /*white-space: nowrap;*/
        /*overflow: hidden;*/
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        height:48px;
    }
    .views-date {
        color: #9E9E9E;
    }
</style>
